import { TooltipedTextComponent } from 'commons/components';
import { sortAndJoin } from 'commons/utils/sort.utils';
import { useTranslation } from 'core/i18n';
import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { DELETE_MODAL_KEY } from './use-delete-eap-setting.constants';

export const DeleteEapSettingHeader: React.FC<{ eapSettings: EapSettings[] }> = ({ eapSettings }) => {
    const { t } = useTranslation();
    return eapSettings.length === 1 ? (
        <>
            {t(DELETE_MODAL_KEY.title.one, {
                name: eapSettings[0].name,
            })}
        </>
    ) : (
        <TooltipedTextComponent
            i18nKey={DELETE_MODAL_KEY.title.multiple}
            tooltipText={sortAndJoin(eapSettings.map((es) => es.name))}
            i18nValues={{ number: eapSettings.length }}
            tooltipAnchorClassname="blue-tooltip-span"
            showTooltipAlways
        />
    );
};
